import { Component } from '@angular/core';
import { APIOnLine } from "../../services/api/api.services";
import { ActionSheetController, App, ToastController, Events, Nav } from 'ionic-angular';
import { Navegacion } from '../../models/online/navegacion';
import { pouchdb2 } from '../../services/pouchdb/pouchdb.service';
import { Proxy } from '../../services/proxy/proxy.service';
import { ProyectoGanarService } from '../../services/api/ganar.services';

@Component({
  selector: 'cabecera-designacion',
  templateUrl: 'cabecera.html'
})
export class CabeceraComponent {

  // #region Propiedades del controlador
  public deshabilitado: boolean = false;
  public designacion: Proxy.PrDesignaciones;
  public navegar: Navegacion.Navegar;
  public golesLocales: number;
  public golesVisitante: number;
  public esUltimaPagina: boolean = false;
  // #endregion

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public app: App,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public events: Events,
    public Persistentes: APIOnLine.Persistentes,
    public proyectoGanarService: ProyectoGanarService,
    public toastCtrl: ToastController
  ) {
    try {
      console.log("Inicialización de la cabecera realizada (constructor)");
      this.navegar = new Navegacion.Navegar(this.actionSheetCtrl, this.app, this.CFutbolActas, this.DBService2, this.Persistentes, this.proyectoGanarService, this.toastCtrl);
      this.designacion = this.Persistentes.GetDesignacion();
      this.golesLocales = this.Persistentes.GetGolesLocal();
      this.golesVisitante = this.Persistentes.GetGolesVisitante();

      // Detección de la última página
      let nav: Nav = this.app.getRootNav();
      if (nav.getActive().name == "FinalizarPage") {
        this.esUltimaPagina = true;
      }
      else {
        this.esUltimaPagina = false;
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  ngOnInit() {
    // Suscripción a eventos
    this.events.subscribe("cabecera:cambioEstado", () => {
      this.designacion = this.Persistentes.GetDesignacion();
    });
    this.events.subscribe("cabecera:actualizarResultado", () => {
      this.golesLocales = this.Persistentes.GetGolesLocal() != null ? this.Persistentes.GetGolesLocal() : 0;
      this.golesVisitante = this.Persistentes.GetGolesVisitante() != null ? this.Persistentes.GetGolesVisitante() : 0;
      // let resultado:Proxy.PrResultado = new Proxy.PrResultado(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion);

      // resultado.Obtener()
      //   .then((datos:boolean|void) => {
      //     this.golesLocales = resultado.golesLocales;
      //     this.golesVisitante = resultado.golesVisitantes;
      //   });
    });
  }

  public ActualizarDesignacion(parametro1: any, parametro2: any): void { }

  public ClaseEstado(): string {
    return this.designacion.OtrosDatos.estadoProvisional.toLowerCase().replace(" ", "-");
  }

  /**
   * Deshabilita el botón para seguir a la siguiente página
   */
  public Deshabilitar(): void {
    this.deshabilitado = true;
  }

  /**
   * Habilita el botón para seguir a la siguiente página
   */
  public Habilitar(): void {
    this.deshabilitado = false;
  }

}



// WEBPACK FOOTER //
// ./src/components/cabecera/cabecera.ts